module.exports = __webpack_public_path__ + "img/tuurro.c6.w.26cea96d.png";